import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import WhyHostBlock8 from './WhyHostBlock8';
import { restrictUrls } from '../../../../helpers/adminPrivileges';

const title = 'Why Become Owner Block 8';

export default async function action({ store }) {

        let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
        const adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
        const privileges = store.getState().listSettings && store.getState().listSettings.privileges;
    
        if (!isAdminAuthenticated) {
            return { redirect: '/siteadmin/login' };
        }
    
        // Admin restriction
        // if (!restrictUrls('/siteadmin/whyHost/Block8', adminPrivileges, privileges)) {
        //     return { redirect: '/siteadmin' };
        // }

        return {
            title,
            component: <AdminLayout><WhyHostBlock8 title={title} /></AdminLayout>,
        };
    };
